<template>
    <main class="main-container">
        <Head class="main-header"></Head>
        <slot name="main"></slot>
        <Foot class="main-footer" v-if="!noFoot"></Foot>
    </main>
</template>

<script>
import Head from '@/views/Head.vue';
import Foot from '@/views/Foot.vue';

export default {
    name: 'Layout',
    components: {
        Head,
        Foot,
    },
    props: {
        title: String,
        noFoot: Boolean,
    },
    data() {
        return {
            oriTitle: window.document.title,
        };
    },
    watch: {
        title() {
            window.document.title = this.$props.title;
        },
    },
    mounted() {
        if (this.$props.title) {
            window.document.title = this.$props.title;
        }
    },
    destroyed() {
        window.document.title = this.oriTitle;
    },
    methods: {

    },
};
</script>
<style lang="less" scoped>
    .main-container {
        padding-top: 50px;
        .main-header {
            position: fixed;
            left: 0;
            top: 0;
            width: 100%;
            height: 50px;
            z-index: 999;
        }
        .main-footer {
            background: #4A4A4A;
        }
    }
</style>
